import Vue from 'vue';
import Vuex from 'vuex';
import account_details from './modules/account_details';
import auth from './modules/auth';
import locale from './modules/locale';
import moments from './modules/moments';
import order_salt from './modules/order_salt';
import orders from './modules/orders';
import proposal_progress from './modules/proposal_progress';
import referrals from './modules/referrals';
import support_wizard from './modules/support_wizard';
import experiences from './modules/experiences';
import available_contact_moments from './modules/available_contact_moments';
import plan_installation from './modules/plan_installation';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        account_details,
        auth,
        locale,
        moments,
        order_salt,
        orders,
        plan_installation,
        proposal_progress,
        referrals,
        support_wizard,
        experiences,
        available_contact_moments
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js